import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import { PermissionsGuard } from './components';
import {
    CHART_FUNNEL_BY_PROSPECTING_STATUS_REPORT_AUTH,
    CHART_FUNNEL_STATUS_BY_TEMPERATURE_REPORT_AUTH,
    CHART_MASTER_REPORT_AUTH,
    CHART_PROSPECTING_BY_DATE_AND_MODEL_REPORT_AUTH,
    CHART_PROSPECTING_BY_HOURS_REPORT_AUTH,
    DASHBOARD_APPOINTMENTS_REPORT_AUTH,
    DASHBOARD_GENERAL_REPORT_AUTH,
    DASHBOARD_GOALS_REPORT_AUTH,
    DASHBOARD_SALES_REPORT_AUTH,
    DASHBOARD_VISITS_REPORT_AUTH,
    DRILLDOWN_APPOINTMENTS_DETAILED_ANALYSIS_REPORT_AUTH,
    DRILLDOWN_CALLS_DETAILED_ANALYSIS_REPORT_AUTH,
    DRILLDOWN_GLOBAL_PROSPECTING_BY_SOURCES_REPORT_AUTH,
    DRILLDOWN_GLOBAL_PROSPECTING_BY_TEMPERATURE_REPORT_AUTH,
    DRILLDOWN_LEADS_WITHOUT_ASSIGNMENT_REPORT_AUTH,
    DRILLDOWN_PROSPECTING_BY_AGENTS_REPORT_AUTH,
    DRILLDOWN_SALES_DETAILED_ANALYSIS_REPORT_AUTH,
    DRILLDOWN_VISITS_DETAILED_ANALYSIS_REPORT_AUTH,
    READ_PERMISSION,
    TABLE_ADDONS_USAGE_REPORT_AUTH,
    TABLE_AGENTS_CALLS_REPORT_AUTH,
    TABLE_AGENTS_COMPARATIVE_REPORT_AUTH,
    TABLE_AI_CALLS_REPORT_AUTH,
    TABLE_CALL_PERFORMANCE_REPORT_AUTH,
    TABLE_EXTRA_SCORES_REPORT_AUTH,
    TABLE_FOLLOW_UP_BY_AGENTS_REPORT_AUTH,
    TABLE_FOLLOW_UP_TIME_REPORT_AUTH,
    TABLE_INVESTMENTS_BY_CAMPAIGNS_REPORT_AUTH,
    TABLE_PENDING_TASKS_BY_AGENCIES_REPORT_AUTH,
    TABLE_PROSPECTING_AGENCIES_REPORT_AUTH,
    TABLE_PROSPECTING_AGENT_SOURCES_REPORT_AUTH,
    TABLE_PROSPECTING_MODELS_REPORT_AUTH,
    TABLE_PROSPECTING_SOURCES_REPORT_AUTH,
    TABLE_PROSPECTING_TOTAL,
    TABLE_PROSPECTS_WITH_VISITS_REPORT_AUTH,
    TABLE_STORES_SCORES_REPORT_AUTH,
    TABLE_TEMPERATURES_SUBSTATUS_REPORT_AUTH,
    TABLE_FOLLOW_UP_RESPONSE_TIME_REPORT_AUTH,
    INVESTMENTS_CHART_AUTH,
    CREATE_PERMISSION,
    UPDATE_PERMISSION,
    REPORT_WARBOX_MESSAGES_ANALYTICS,
} from 'src/constants/permissions';

export const Dashboards = [
    {
        exact: true,
        path: '/dashboards/goalsv2',
        component: () => <Redirect to="/dashboards/goals" />,
    },
    {
        exact: true,
        path: '/dashboards/dashboardv2',
        component: () => <Redirect to="/dashboards/general" />,
    },
    {
        exact: true,
        path: '/dashboards/general',
        guard: PermissionsGuard,
        roles: {
            permission: DASHBOARD_GENERAL_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/reports/DashboardV2')),
    },
    {
        exact: true,
        path: '/dashboards/appointments',
        guard: PermissionsGuard,
        roles: {
            permission: DASHBOARD_APPOINTMENTS_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/reports/AppointmentsView')),
    },
    {
        exact: true,
        path: '/dashboards/visits',
        guard: PermissionsGuard,
        roles: {
            permission: DASHBOARD_VISITS_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/reports/VisitsView')),
    },
    {
        exact: true,
        path: '/dashboards/sales',
        guard: PermissionsGuard,
        roles: {
            permission: DASHBOARD_SALES_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/reports/FinancingView')),
    },
    {
        exact: true,
        path: '/dashboards/goals',
        guard: PermissionsGuard,
        roles: {
            permission: DASHBOARD_GOALS_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/reports/GoalsDashboardV2')),
    },
];

export const Drilldowns = [
    {
        exact: true,
        path: '/drilldowns/global-prospecting-by-temperature',
        guard: PermissionsGuard,
        roles: {
            permission: DRILLDOWN_GLOBAL_PROSPECTING_BY_TEMPERATURE_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/chartLeads/allHighchart')),
    },
    {
        exact: true,
        path: '/drilldowns/global-prospecting-by-sources',
        guard: PermissionsGuard,
        roles: {
            permission: DRILLDOWN_GLOBAL_PROSPECTING_BY_SOURCES_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(
            () => import('src/views/chartLeads/captacionMediosHighchart')
        ),
    },
    {
        exact: true,
        path: '/drilldowns/appointment-detailed-analysis',
        guard: PermissionsGuard,
        roles: {
            permission: DRILLDOWN_APPOINTMENTS_DETAILED_ANALYSIS_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(
            () => import('src/views/chartLeads/DrilldownAppointments')
        ),
    },
    {
        exact: true,
        path: '/drilldowns/prospecting-by-agents',
        guard: PermissionsGuard,
        roles: {
            permission: DRILLDOWN_PROSPECTING_BY_AGENTS_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/chartLeads/DrilldownLeads')),
    },
    {
        exact: true,
        path: '/drilldowns/sales-detailed-analysis',
        guard: PermissionsGuard,
        roles: {
            permission: DRILLDOWN_SALES_DETAILED_ANALYSIS_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/chartLeads/DrilldownModels')),
    },
    {
        exact: true,
        path: '/drilldowns/leads-without-assignment',
        guard: PermissionsGuard,
        roles: {
            permission: DRILLDOWN_LEADS_WITHOUT_ASSIGNMENT_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(
            () => import('src/views/chartLeads/DrilldownPendingLeads')
        ),
    },
    {
        exact: true,
        path: '/drilldowns/visits-detailed-analysis',
        guard: PermissionsGuard,
        roles: {
            permission: DRILLDOWN_VISITS_DETAILED_ANALYSIS_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/chartLeads/DrilldownVisits')),
    },
    {
        exact: true,
        path: '/drilldowns/calls-detailed-analysis',
        guard: PermissionsGuard,
        roles: {
            permission: DRILLDOWN_CALLS_DETAILED_ANALYSIS_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/chartLeads/DrilldownCalls')),
    },
];

export const Reports = [
    {
        exact: true,
        path: '/reports/call-performance',
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_CALL_PERFORMANCE_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() =>
            import('src/views/chartLeads/UserCallPerformance').then(
                (module) => ({ default: module.UserCallPerformance })
            )
        ),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_PROSPECTING_MODELS_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/reports/prospecting-models',
        component: lazy(() => import('src/views/chartLeads/ModelsProspects')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_PROSPECTING_SOURCES_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/reports/prospecting-sources',
        component: lazy(() => import('src/views/chartLeads/SourcesProspects')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_AI_CALLS_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/reports/ai-calls',
        component: lazy(() => import('src/views/chartLeads/AIReport')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: REPORT_WARBOX_MESSAGES_ANALYTICS,
            crud: READ_PERMISSION,
        },
        path: '/reports/warbox-messages',
        component: lazy(
            () => import('src/views/chartLeads/WarboxMessagesAnalytics')
        ),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_PROSPECTING_TOTAL,
            crud: READ_PERMISSION,
        },
        path: '/reports/prospecting-total',
        component: lazy(() => import('src/views/chartLeads/SystemReport')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_PROSPECTING_AGENCIES_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/reports/prospecting-agencies',
        component: lazy(() => import('src/views/chartLeads/AgenciesProspects')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_AGENTS_COMPARATIVE_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/reports/agents-comparative',
        component: lazy(() => import('src/views/chartLeads/AgentsComparative')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_PROSPECTING_AGENT_SOURCES_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/reports/prospecting-agents-sources',
        component: lazy(
            () => import('src/views/chartLeads/SourcesAgentComparative')
        ),
    },
    {
        exact: true,
        path: '/reports/agents-calls',
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_AGENTS_CALLS_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/chartLeads/AgentsCalls')),
    },
    {
        exact: true,
        path: '/reports/temperatures-substatus',
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_TEMPERATURES_SUBSTATUS_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/chartLeads/AgentsLeads')),
    },
    {
        exact: true,
        path: '/reports/stores-score',
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_STORES_SCORES_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/chartLeads/storesScores')),
    },
    {
        exact: true,
        path: '/reports/follow-up-by-agents',
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_FOLLOW_UP_BY_AGENTS_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/chartLeads/monitoringAgents')),
    },
    {
        exact: true,
        path: '/reports/prospects-with-visits',
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_PROSPECTS_WITH_VISITS_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/chartLeads/VisitsReport')),
    },
    {
        exact: true,
        path: '/reports/investments-by-campaigns',
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_INVESTMENTS_BY_CAMPAIGNS_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/chartLeads/matrixInvestment')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_FOLLOW_UP_TIME_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/reports/follow-up-time',
        component: lazy(() => import('src/views/chartLeads/reportSales')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_FOLLOW_UP_RESPONSE_TIME_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/reports/follow-up-response-time',
        component: lazy(
            () => import('src/views/reports/FollowUpResponseTimeView')
        ),
    },
    {
        exact: true,
        path: '/reports/pending-tasks-by-agencies',
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_PENDING_TASKS_BY_AGENCIES_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/chartLeads/taskStoreChart')),
    },
];

export const InternalReports = [
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_ADDONS_USAGE_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/internal/addons-usage',
        component: lazy(() => import('src/views/charts/AddonsReport')),
    },
    {
        exact: true,
        path: '/internal/extra-scores',
        guard: PermissionsGuard,
        roles: {
            permission: TABLE_EXTRA_SCORES_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/chartLeads/storesExtraScores')),
    },
];

export const Charts = [
    {
        exact: true,
        path: '/charts/master-report',
        guard: PermissionsGuard,
        roles: {
            permission: CHART_MASTER_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/chartLeads/unitComparative2')),
    },
    {
        exact: true,
        path: '/charts/prospecting-by-date-and-model',
        guard: PermissionsGuard,
        roles: {
            permission: CHART_PROSPECTING_BY_DATE_AND_MODEL_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(
            () => import('src/views/chartLeads/UnitComparativeMultiple')
        ),
    },
    {
        exact: true,
        path: '/charts/funnel-status-by-temperature',
        guard: PermissionsGuard,
        roles: {
            permission: CHART_FUNNEL_STATUS_BY_TEMPERATURE_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/chartLeads/temperaturesChart')),
    },
    {
        exact: true,
        path: '/charts/prospecting-by-hours',
        guard: PermissionsGuard,
        roles: {
            permission: CHART_PROSPECTING_BY_HOURS_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/chartLeads/hoursHighchart')),
    },
    {
        exact: true,
        path: '/charts/funnel-prospecting-by-status',
        guard: PermissionsGuard,
        roles: {
            permission: CHART_FUNNEL_BY_PROSPECTING_STATUS_REPORT_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/chartLeads/pyramidHighchart')),
    },
];

export const InvestmentChart = [
    {
        exact: true,
        path: '/create/investment-chart',
        guard: PermissionsGuard,
        roles: {
            permission: INVESTMENTS_CHART_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: lazy(
            () => import('src/views/InvestmentChart/ChartCreateView')
        ),
    },
    {
        exact: true,
        path: '/management/investments-chart/:id',
        guard: PermissionsGuard,
        roles: {
            permission: INVESTMENTS_CHART_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(
            () => import('src/views/InvestmentChart/ChartDetailsView')
        ),
    },
    {
        exact: true,
        path: '/management/investments-chart/:id/edit',
        guard: PermissionsGuard,
        roles: {
            permission: INVESTMENTS_CHART_AUTH,
            crud: UPDATE_PERMISSION,
        },
        component: lazy(
            () => import('src/views/InvestmentChart/ChartEditView')
        ),
    },
    {
        exact: true,
        path: '/management/investments-chart',
        guard: PermissionsGuard,
        roles: {
            permission: INVESTMENTS_CHART_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(
            () => import('src/views/InvestmentChart/ChartListView')
        ),
    },
];
